import SearchAutocomplete from './search-autocomplete';

export default SearchAutocomplete;
